var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { DateTime } from 'luxon';
import { useQuery } from 'react-query';
import { useGraphqlRequest, useCompassScopeCreated } from 'shared/hooks';
import { EHR_LAUNCH_APPOINTMENT_DATE } from '../../config';
import { useMe, useUserIdFromToken } from './useMe';
import { getAllPagesOfAppointments } from './usePages';
/**
 * Builds a memberid indexed collection of appointment arrays.  So we can look at a given
 * member and find any previous appointments they had.
 *
 * @param apptData
 * @returns
 */
export var getMemberAppointmentIndex = function (apptData) {
    var orderedAppointments = apptData === null || apptData === void 0 ? void 0 : apptData.sort(function (a, b) {
        var dta = DateTime.fromISO(a.start_at);
        var dtb = DateTime.fromISO(b.start_at);
        if (dta < dtb)
            return -1;
        if (dta > dtb)
            return 1;
        return 0;
    });
    var ordered = orderedAppointments === null || orderedAppointments === void 0 ? void 0 : orderedAppointments.reduce(function (out, a) {
        var _a, _b, _c;
        if (!Array.isArray(out[((_a = a.member) === null || _a === void 0 ? void 0 : _a.id) || '']))
            out[((_b = a.member) === null || _b === void 0 ? void 0 : _b.id) || ''] = [];
        out[((_c = a.member) === null || _c === void 0 ? void 0 : _c.id) || ''].push(a);
        return out;
    }, {});
    return ordered;
};
/**
 * given an appointment index and an appointment, this finds any previous ones for that member, if any.
 * @param currentAppointment
 * @param appointmentIndex
 * @returns
 */
export var findLastAppointment = function (currentAppointment, appointmentIndex) {
    var _a;
    if (!appointmentIndex || !currentAppointment)
        return null;
    var memAppts = appointmentIndex[((_a = currentAppointment.member) === null || _a === void 0 ? void 0 : _a.id) || ''];
    var currentAppointmentIndex = memAppts.findIndex(function (a) { return a.id === currentAppointment.id; });
    if (currentAppointmentIndex === 0)
        return null;
    return memAppts[currentAppointmentIndex - 1];
};
export var useMyAppointments = function (disabled) {
    var _a, _b;
    var request = useGraphqlRequest().request;
    var me = useMe();
    var providerId = (_b = (_a = me.data) === null || _a === void 0 ? void 0 : _a.care_provider) === null || _b === void 0 ? void 0 : _b.id;
    var userId = useUserIdFromToken();
    var compassScopeCreateAt = useCompassScopeCreated();
    return useQuery(['myAppointments', userId], function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, getAllPagesOfAppointments(userId || '', providerId || '', request, compassScopeCreateAt || '')];
        });
    }); }, {
        refetchOnWindowFocus: false,
        cacheTime: 1000 * 60 * 60 * 1,
        staleTime: 1000 * 60 * 60 * 1,
        enabled: !!me.data && !!userId && !!compassScopeCreateAt && !disabled,
    });
};
export var useMemberAppointments = function (_a) {
    var userId = _a.userId;
    var request = useGraphqlRequest().request;
    return useQuery(['memberAppointments', userId], function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
        return [2 /*return*/, getAllPagesOfAppointments(userId || '', '', request, EHR_LAUNCH_APPOINTMENT_DATE)];
    }); }); }, {
        refetchOnWindowFocus: false,
        cacheTime: 1000 * 60 * 60 * 1,
        staleTime: 1000 * 60 * 60 * 1,
        enabled: !!userId,
    });
};
export var useMemberUpcomingAppointments = function (_a) {
    var userId = _a.userId;
    var request = useGraphqlRequest().request;
    return useQuery(['upcoming-member-appointments', userId], function () { return __awaiter(void 0, void 0, void 0, function () {
        var appointments;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0: return [4 /*yield*/, getAllPagesOfAppointments(userId || '', '', request, DateTime.now().toFormat('MM/dd/yyyy'))];
                case 1:
                    appointments = _b.sent();
                    return [2 /*return*/, (_a = appointments === null || appointments === void 0 ? void 0 : appointments.appointments) === null || _a === void 0 ? void 0 : _a.filter(function (a) { return DateTime.fromISO(a.start_at) > DateTime.now(); })];
            }
        });
    }); }, {
        refetchOnWindowFocus: false,
        cacheTime: 1000 * 60 * 60 * 1,
        staleTime: 1000 * 60 * 60 * 1,
        enabled: !!userId,
    });
};
